import { useQuery } from '@tanstack/react-query';
import { checkout } from '..';
import { getCheckoutOpts } from '../getCheckoutState/getCheckoutState';

export interface BankInfoData {
  bankName: string;
  accountNumber: string;
  routingNumber: string;
}

const fetchBankInfoData = (checkoutUuid: string) =>
  checkout.get<BankInfoData>(`/v1/bank-info/${checkoutUuid}`, {validateStatus: (status) => [200, 404].includes(status)}).then((res) => res.data);

export const useBankInfo = (applicationId?: string) => {
  
  const { data: checkoutData, isLoading: isLoadingCheckout, error: checkoutError } = useQuery({
    ...getCheckoutOpts(applicationId),
  });
  
 const { data: bankInfo, isLoading: isLoadingBankInfo, error: bankInfoError } = useQuery({
  queryKey: ['bankInfo', checkoutData?.checkoutUuid],
  queryFn: () => fetchBankInfoData(checkoutData?.checkoutUuid!),
  enabled: !!checkoutData?.checkoutUuid,
});
  
  return {
    bankInfo,
    isLoadingBankInfo: isLoadingCheckout || isLoadingBankInfo,
    isErrorBankInfo: !!checkoutError || !!bankInfoError
  };
};

export default useBankInfo;